export const popupContainerClass = "POPUP_CONTAINER";

export const getPopupContainer = (el: HTMLElement): HTMLElement => {
  const container = el.closest(`.${popupContainerClass}`) as HTMLElement | null;
  return container ?? document.body;
};
